import * as player from './player';
import * as event from './event';
import * as internalMessage from './internal-message';
import * as kyc from './kyc';
import * as responsibleGaming from './responsible-gaming';
import * as wallet from './wallet';
import * as transaction from './transaction';
import * as payment from './payment';
import * as bonus from './bonus';
import * as playerGroups from './player-groups';
import * as tournament from './tournament';
import * as casino from './casino';
import * as bingo from './bingo';
import * as currencies from './currencies';

export default {
  player: player,
  event: event,
  internalMessage: internalMessage,
  kyc: kyc,
  responsibleGaming: responsibleGaming,
  wallet: wallet,
  transaction: transaction,
  payment: payment,
  bonus: bonus,
  playerGroups: playerGroups,
  tournament: tournament,
  casino: casino,
  bingo: bingo,
  currencies: currencies
};